import http from "./https";

export const login = async (param) => {
  const { data } = await http.post("/login",{
    ...param
  });
  return data;
};
